import axios from 'axios';

export function createEmailDomain(name) {
  return axios
    .post('/api/?entity=vessel&action=createEmailDomain', {name})
    .then(response => response.data && response.data.data)
    .catch(error => {
      if (error.response && error.response.status === 422) {
        return Promise.reject({code: 422, message: error.response.data.message})
      }
    });
}
